export enum USER_ERROR_CODE {
  EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE',
}

export interface UserProfile {
  id: string;
  first_name: string;
  last_name: string | null;
  email: string;
  phone_number: string | null;
  language: string;
}

export type UserProfileUpdateRequest = Omit<UserProfile, 'id'>;

export interface PasswordChangeRequest {
  old_password: string;
  new_password: string;
}
